import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCompany,
  getParticularPage,
  getNext,
  getPrevious,
  createCompany,
  updateCompany,
  handleSearch,
} from "./thunk";

const initialState = {
  companies: [],
  edit: false,
  company: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCompany: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },
  activeCompanyId: null,
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    companyEditSuccess: (state, action) => {
      state.edit = true;
      state.company = state.companies.find((company) => company.id === action.payload);
      state.formData = state.companies.find((company) => company.id === action.payload);
      state.activeCompanyId = action.payload;
    },
    resetCompanyForm: (state, action) => {
      if (action.payload) {
        // if edit is true, reset to company data
        state.formData = state.company;
      } else {
        state.formData = initialState.formData; // if edit is false, reset to initial state
        state.activeCompanyId = null;
      }
    },
    saveCompanyForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllCompany: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCompany = false;
      state.company = null;
      state.formData = initialState.formData;
      state.activeCompanyId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCompany.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCompany.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCompany.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateCompany.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCompany.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCompany.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCompany.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCompany = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCompany.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCompany = false;
        state.companies = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCompany.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCompany = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, companyEditSuccess, saveCompanyForm, resetCompanyForm, clearAllCompany } =
  companySlice.actions;

export default companySlice.reducer;
